import React, { RefObject, useState } from "react";
import { Box, IconButton, MenuItem, PopoverActions } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { LocationDropdownProps } from "../LocationDropdown";
import { zoneI } from "../../../../../../../hooks/UbicationFilterContext";

const NestedLocation = ({
  ubication,
  onSelect,
  popoverActionRef,
}: {
  ubication: zoneI;
  onSelect: (ubication: zoneI) => void;
  popoverActionRef?: RefObject<PopoverActions>;
}) => {
  const [showChildren, setSetshowChildren] = useState(false);

  const handleOpenDropdown = (e: React.MouseEvent) => {
    setTimeout(() => {
      popoverActionRef?.current?.updatePosition();
    }, 0);
    e.stopPropagation();
    e.preventDefault();
    setSetshowChildren((prevState) => !prevState);
  };

  const haveZones = (ubication.zoneDataList?.length ?? 0) > 0;
  const haveHotels = (ubication.hotelDataList?.length ?? 0) > 0;
  const haveChildren = haveZones || haveHotels;

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
        }}
      >
        <MenuItem
          key={ubication.id}
          onClick={() => onSelect(ubication)}
          sx={{
            flex: 1,
            ...(haveChildren && {
              paddingLeft: 0,
            }),
          }}
        >
          {haveChildren && (
            <IconButton onClick={handleOpenDropdown} size="small">
              <ArrowDropDownIcon
                fontSize="large"
                sx={{
                  ...(!showChildren && {
                    transform: "rotate(-90deg)",
                  }),
                }}
              />
            </IconButton>
          )}
          {ubication.name}
        </MenuItem>
      </Box>
      {showChildren && (
        <>
          {haveZones &&
            ubication.zoneDataList?.map((zone) => (
              <NestedLocation ubication={zone} onSelect={onSelect} />
            ))}
          {haveHotels &&
            ubication.hotelDataList?.map((hotel) => (
              <MenuItem
                key={hotel.id}
                onClick={() => onSelect(hotel)}
                sx={{
                  flex: 1,
                  paddingLeft: "2rem",
                }}
              >
                {hotel.name}
              </MenuItem>
            ))}
        </>
      )}
    </Box>
  );
};

const NestedLocationDropdown: React.FC<LocationDropdownProps> = ({
  ubicationFilterList,
  onSelect,
  popoverActionRef,
}) => {
  return (
    <Box>
      {ubicationFilterList.map((ubication) => (
        <NestedLocation
          ubication={ubication}
          onSelect={onSelect}
          popoverActionRef={popoverActionRef}
        />
      ))}
    </Box>
  );
};
export default NestedLocationDropdown;
